// ---------------- Contact Info ----------------
export const FETCH_CONTACT_INFO_REQUEST = "FETCH_CONTACT_INFO_REQUEST";
export const FETCH_CONTACT_INFO_SUCCESS = "FETCH_CONTACT_INFO_SUCCESS";
export const FETCH_CONTACT_INFO_FAILURE = "FETCH_CONTACT_INFO_FAILURE";

export const CREATE_CONTACT_INFO_REQUEST = "CREATE_CONTACT_INFO_REQUEST";
export const CREATE_CONTACT_INFO_SUCCESS = "CREATE_CONTACT_INFO_SUCCESS";
export const CREATE_CONTACT_INFO_FAILURE = "CREATE_CONTACT_INFO_FAILURE";

export const UPDATE_CONTACT_INFO_REQUEST = "UPDATE_CONTACT_INFO_REQUEST";
export const UPDATE_CONTACT_INFO_SUCCESS = "UPDATE_CONTACT_INFO_SUCCESS";
export const UPDATE_CONTACT_INFO_FAILURE = "UPDATE_CONTACT_INFO_FAILURE";

// ---------------- Business Info ----------------
export const FETCH_BUSINESS_INFO_REQUEST = "FETCH_BUSINESS_INFO_REQUEST";
export const FETCH_BUSINESS_INFO_SUCCESS = "FETCH_BUSINESS_INFO_SUCCESS";
export const FETCH_BUSINESS_INFO_FAILURE = "FETCH_BUSINESS_INFO_FAILURE";

export const CREATE_BUSINESS_INFO_REQUEST = "CREATE_BUSINESS_INFO_REQUEST";
export const CREATE_BUSINESS_INFO_SUCCESS = "CREATE_BUSINESS_INFO_SUCCESS";
export const CREATE_BUSINESS_INFO_FAILURE = "CREATE_BUSINESS_INFO_FAILURE";

export const UPDATE_BUSINESS_INFO_REQUEST = "UPDATE_BUSINESS_INFO_REQUEST";
export const UPDATE_BUSINESS_INFO_SUCCESS = "UPDATE_BUSINESS_INFO_SUCCESS";
export const UPDATE_BUSINESS_INFO_FAILURE = "UPDATE_BUSINESS_INFO_FAILURE";

// ---------------- Officers ----------------
export const FETCH_OFFICERS_REQUEST = "FETCH_OFFICERS_REQUEST";
export const FETCH_OFFICERS_SUCCESS = "FETCH_OFFICERS_SUCCESS";
export const FETCH_OFFICERS_FAILURE = "FETCH_OFFICERS_FAILURE";

export const CREATE_OFFICERS_REQUEST = "CREATE_OFFICERS_REQUEST";
export const CREATE_OFFICERS_SUCCESS = "CREATE_OFFICERS_SUCCESS";
export const CREATE_OFFICERS_FAILURE = "CREATE_OFFICERS_FAILURE";

export const UPDATE_OFFICERS_REQUEST = "UPDATE_OFFICERS_REQUEST";
export const UPDATE_OFFICERS_SUCCESS = "UPDATE_OFFICERS_SUCCESS";
export const UPDATE_OFFICERS_FAILURE = "UPDATE_OFFICERS_FAILURE";



// ---------------- References ----------------
export const FETCH_REFERENCES_REQUEST = "FETCH_REFERENCES_REQUEST";
export const FETCH_REFERENCES_SUCCESS = "FETCH_REFERENCES_SUCCESS";
export const FETCH_REFERENCES_FAILURE = "FETCH_REFERENCES_FAILURE";

export const UPDATE_REFERENCES_REQUEST = "UPDATE_REFERENCES_REQUEST";
export const UPDATE_REFERENCES_SUCCESS = "UPDATE_REFERENCES_SUCCESS";
export const UPDATE_REFERENCES_FAILURE = "UPDATE_REFERENCES_FAILURE";



// ---------------- Relationships ----------------
export const FETCH_OVERSEAS_RELATIONSHIPS_REQUEST = "FETCH_OVERSEAS_RELATIONSHIPS_REQUEST";
export const FETCH_OVERSEAS_RELATIONSHIPS_SUCCESS = "FETCH_OVERSEAS_RELATIONSHIPS_SUCCESS";
export const FETCH_OVERSEAS_RELATIONSHIPS_FAILURE = "FETCH_OVERSEAS_RELATIONSHIPS_FAILURE";

export const CREATE_OVERSEAS_RELATIONSHIPS_REQUEST = "CREATE_OVERSEAS_RELATIONSHIPS_REQUEST";
export const CREATE_OVERSEAS_RELATIONSHIPS_SUCCESS = "CREATE_OVERSEAS_RELATIONSHIPS_SUCCESS";
export const CREATE_OVERSEAS_RELATIONSHIPS_FAILURE = "CREATE_OVERSEAS_RELATIONSHIPS_FAILURE";


// ---------------- Expectations ----------------
export const FETCH_EXPECTATIONS_REQUEST = "FETCH_EXPECTATIONS_REQUEST";
export const FETCH_EXPECTATIONS_SUCCESS = "FETCH_EXPECTATIONS_SUCCESS";
export const FETCH_EXPECTATIONS_FAILURE = "FETCH_EXPECTATIONS_FAILURE";

export const UPDATE_EXPECTATIONS_REQUEST = "UPDATE_EXPECTATIONS_REQUEST";
export const UPDATE_EXPECTATIONS_SUCCESS = "UPDATE_EXPECTATIONS_SUCCESS";
export const UPDATE_EXPECTATIONS_FAILURE = "UPDATE_EXPECTATIONS_FAILURE";



// ---------------- Legal Form ----------------
export const FETCH_LEGAL_FORM_REQUEST = "FETCH_LEGAL_FORM_REQUEST";
export const FETCH_LEGAL_FORM_SUCCESS = "FETCH_LEGAL_FORM_SUCCESS";
export const FETCH_LEGAL_FORM_FAILURE = "FETCH_LEGAL_FORM_FAILURE";

export const UPDATE_LEGAL_FORM_REQUEST = "UPDATE_LEGAL_FORM_REQUEST";
export const UPDATE_LEGAL_FORM_SUCCESS = "UPDATE_LEGAL_FORM_SUCCESS";
export const UPDATE_LEGAL_FORM_FAILURE = "UPDATE_LEGAL_FORM_FAILURE";


// ---------------- Declaration ----------------
export const FETCH_DECLARATION_REQUEST = "FETCH_DECLARATION_REQUEST";
export const FETCH_DECLARATION_SUCCESS = "FETCH_DECLARATION_SUCCESS";
export const FETCH_DECLARATION_FAILURE = "FETCH_DECLARATION_FAILURE";

export const UPDATE_DECLARATION_REQUEST = "UPDATE_DECLARATION_REQUEST";
export const UPDATE_DECLARATION_SUCCESS = "UPDATE_DECLARATION_SUCCESS";
export const UPDATE_DECLARATION_FAILURE = "UPDATE_DECLARATION_FAILURE";



// -------------------- Documents ----------------
export const FETCH_DOCUMENTS_REQUEST = "FETCH_DOCUMENTS_REQUEST";
export const FETCH_DOCUMENTS_SUCCESS = "FETCH_DOCUMENTS_SUCCESS";
export const FETCH_DOCUMENTS_FAILURE = "FETCH_DOCUMENTS_FAILURE";

export const UPLOAD_DOCUMENTS_REQUEST = "UPLOAD_DOCUMENTS_REQUEST";
export const UPLOAD_DOCUMENTS_SUCCESS = "UPLOAD_DOCUMENTS_SUCCESS";
export const UPLOAD_DOCUMENTS_FAILURE = "UPLOAD_DOCUMENTS_FAILURE";



// --------------------- Membership Tiers ----------------------
export const FETCH_MEMBERSHIP_TIERS_REQUEST = "FETCH_MEMBERSHIP_TIERS_REQUEST";
export const FETCH_MEMBERSHIP_TIERS_SUCCESS = "FETCH_MEMBERSHIP_TIERS_SUCCESS";
export const FETCH_MEMBERSHIP_TIERS_FAILURE = "FETCH_MEMBERSHIP_TIERS_FAILURE";


// ---------------- Generic Step Save (optional) ----------------
export const SAVE_STEP_DATA_REQUEST = "SAVE_STEP_DATA_REQUEST";
export const SAVE_STEP_DATA_SUCCESS = "SAVE_STEP_DATA_SUCCESS";
export const SAVE_STEP_DATA_FAILURE = "SAVE_STEP_DATA_FAILURE";



export const SUBMIT_MEMBERSHIP_REQUEST = "SUBMIT_MEMBERSHIP_REQUEST";
export const SUBMIT_MEMBERSHIP_SUCCESS = "SUBMIT_MEMBERSHIP_SUCCESS";
export const SUBMIT_MEMBERSHIP_FAILURE = "SUBMIT_MEMBERSHIP_FAILURE";








// Membership request by membership id
export const FETCH_USER_MEMBERSHIP_REQUEST_REQUEST = "FETCH_USER_MEMBERSHIP_REQUEST_REQUEST";
export const FETCH_USER_MEMBERSHIP_REQUEST_SUCCESS = "FETCH_USER_MEMBERSHIP_REQUEST_SUCCESS";
export const FETCH_USER_MEMBERSHIP_REQUEST_FAILURE = "FETCH_USER_MEMBERSHIP_REQUEST_FAILURE";









// Membership approval, rejection, or query action types 
export const FETCH_MEMBERSHIP_REQUESTS_REQUEST = "FETCH_MEMBERSHIP_REQUESTS_REQUEST";
export const FETCH_MEMBERSHIP_REQUESTS_SUCCESS = "FETCH_MEMBERSHIP_REQUESTS_SUCCESS";
export const FETCH_MEMBERSHIP_REQUESTS_FAILURE = "FETCH_MEMBERSHIP_REQUESTS_FAILURE";



export const FETCH_MEMBERSHIP_REQUEST_DETAILS_REQUEST = "FETCH_MEMBERSHIP_REQUEST_DETAILS_REQUEST";
export const FETCH_MEMBERSHIP_REQUEST_DETAILS_SUCCESS = "FETCH_MEMBERSHIP_REQUEST_DETAILS_SUCCESS";
export const FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE = "FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE";

export const CLEAR_MEMBERSHIP_REQUESTS_ERROR = "CLEAR_LOAN_REQUESTS_ERROR";




export const FETCH_MEMBERSHIP_DETAILS_REQUEST = "FETCH_MEMBERSHIP_DETAILS_REQUEST";
export const FETCH_MEMBERSHIP_DETAILS_SUCCESS = "FETCH_MEMBERSHIP_DETAILS_SUCCESS";
export const FETCH_MEMBERSHIP_DETAILS_FAILURE = "FETCH_MEMBERSHIP_DETAILS_FAILURE";




export const FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_REQUEST = "FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_REQUEST";
export const FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_SUCCESS = "FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_SUCCESS";
export const FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_FAILURE = "FETCH_MEMBERSHIP_CONFIRMATION_DETAILS_FAILURE";
